import { render } from "./KpiTable.vue?vue&type=template&id=747dabc4&ts=true"
import script from "./KpiTable.vue?vue&type=script&lang=ts"
export * from "./KpiTable.vue?vue&type=script&lang=ts"

import "./KpiTable.vue?vue&type=style&index=0&id=747dabc4&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__